/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Injectable } from '@angular/core';

import { DataQuery } from '@typescript-kit/data';
import { HttpService } from '@angular-kit/core';

import { TargetHours, TargetHoursData } from '@teamworks/global';

@Injectable()
export class TargetHoursService {

  constructor(private httpService: HttpService) {
  }

  async loadTargetHoursList(employeeId: string, dataQuery?: DataQuery): Promise<TargetHours[]> {
    return this.httpService.get(`api/time-recording/target-hours-list/${employeeId}`, { 'data-query': dataQuery })
      .then((loadedData: TargetHoursData[]) => loadedData.map(data => new TargetHours(data)));
  }

  async loadTargetHoursListByMonth(employeeId: string, year: string, month: string, dataQuery?: DataQuery): Promise<TargetHours[]> {
    return this.httpService.get(`api/time-recording/target-hours-list/${employeeId}/${year}/${month}`, { 'data-query': dataQuery })
      .then((loadedData: TargetHoursData[]) => loadedData.map(data => new TargetHours(data)));
  }

  async loadTargetHours(employeeId: string, type: string, date: string, dataQuery?: DataQuery): Promise<TargetHours> {
    return this.httpService.get(`api/time-recording/target-hours/${employeeId}/${type}/${date}`, { 'data-query': dataQuery })
      .then((loadedData: TargetHoursData) => loadedData && new TargetHours(loadedData));
  }

  async saveTargetHours(data: TargetHoursData): Promise<TargetHours> {
    return this.httpService.post(`api/time-recording/target-hours`, data)
      .then((savedData: TargetHoursData) => new TargetHours(savedData));
  }

  async deleteTargetHours(employeeId: string, type: string, date: string): Promise<TargetHours> {
    return this.httpService.delete(`api/time-recording/target-hours/${employeeId}/${type}/${date}`)
      .then((deletedData: TargetHoursData) => new TargetHours(deletedData));
  }
}
